__turbopack_context__.v({
  "newsFilters": "News-module-scss-module__Bk4UVa__newsFilters",
  "newsWrap": "News-module-scss-module__Bk4UVa__newsWrap",
  "pageCount": "News-module-scss-module__Bk4UVa__pageCount",
  "pagerButton": "News-module-scss-module__Bk4UVa__pagerButton",
});
